import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/components/AuthForm";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export default function ConfirmEmailPage() {
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    api.post<{ email: string }>("/auth/confirm-email", { token: params.get("token") ?? "" })
      .then((r) => { setMsg({ ok: true, text: `Listo. Tu correo ahora es ${r.data.email}.` }); if (user) refresh().catch(() => undefined); })
      .catch((e) => setMsg({ ok: false, text: formatApiError(e) }));
  }, [params, user, refresh]);
  return (
    <AuthShell title="Confirmar correo" subtitle="Cambio del correo de tu cuenta.">
      <p className={`text-sm ${msg?.ok === false ? "text-rose-600" : "text-slate-600"}`} data-testid="confirm-email-message">{msg ? msg.text : "Confirmando…"}</p>
      <Link to={user ? "/configuracion" : "/login"} className="mt-5 inline-flex h-11 w-full items-center justify-center rounded-md bg-[#1B2A4A] font-semibold text-white" data-testid="confirm-email-continue">Continuar</Link>
    </AuthShell>
  );
}
